/* Copyright Information: Created by BuyGroup */
import Api from "../Api";

export const getProductDetail = (id) => {
  return Api.get("group/" + id)
    .then((res) => res.data)
    .catch((err) => console.log("error in get product detail ", err));
};
/* Copyright Information: Created by BuyGroup */
